// extracted by mini-css-extract-plugin
export var actionButton = "_ei-t";
export var buttonContainer = "_ei-0";
export var buttonContainer2 = "_ei-1";
export var buttonSection = "_ei-2";
export var details = "_ei-3";
export var dropdownItem = "_ei-5";
export var dropdownItemsContainer = "_ei-4";
export var fileInput = "_ei-r";
export var headerButton = "_ei-6";
export var icon = "_ei-7";
export var input = "_ei-8";
export var macroListItem = "_ei-9";
export var mainContent = "_ei-a";
export var microText = "_ei-b";
export var modal = "_ei-w";
export var optionsButton = "_ei-c";
export var paperclip = "_ei-s";
export var pillContent = "_ei-d";
export var preview = "_ei-e";
export var preview2 = "_ei-f";
export var quillEditor = "_ei-q";
export var selectedMacro = "_ei-g";
export var sidebar = "_ei-h";
export var sidebarHeader = "_ei-j";
export var sidebarList = "_ei-i";
export var sidebarListItem = "_ei-k";
export var sidebarSearch = "_ei-l";
export var snoozeDurationWrapper = "_ei-v";
export var statusPillContainer = "_ei-m";
export var tagsContainer = "_ei-n";
export var unselectedMacro = "_ei-o";
export var variable = "_ei-u";
export var wrapper = "_ei-p";